module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.response) ? _c('document-container', {
    attrs: {
      "header": [{
        type: 'Pagetitle',
        title: _vm.response.title,
        subtitle: _vm.response.subtitle,
        position: 'header',
        sort: 1,
        shared: true,
        documentType: 'ddf'
      }],
      "logo": "https://www.dericon.DE/wp-content/uploads/2023/03/Dericon_Logo_990x230.png",
      "documentType": "ddf"
    }
  }, [_c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.response.introduction.split('\n').join('<br>'))
    },
    slot: "raw-body"
  }), _vm._v(" "), _vm._l((_vm.response.fields), function(field) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticStyle: {
        "border-top": "1px solid #d4d4d4",
        "padding-bottom": "10px",
        "padding-top": "10px"
      }
    }, [_c('table', _vm._l((field), function(entry, key) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "120px",
          "color": "rgba(0,0,0,.5)"
        }
      }, [_vm._v(_vm._s(_vm.translations[key][_vm.language]))]), _vm._v(" "), (key === 'mandatory') ? _c('td', [_c('span', {
        staticClass: "material-symbols-rounded",
        class: entry ? 'dericon-success' : 'dericon-error',
        staticStyle: {
          "font-size": "12px",
          "vertical-align": "sub"
        }
      }, [_vm._v("\n                " + _vm._s(entry ? 'check' : 'clear') + "\n              ")])]) : _c('td', [_vm._v(_vm._s(entry))])])
    }), 0)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "pagebreak"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-block sample",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h2', [_vm._v(_vm._s(this.translations.appendix[this.language]))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(this.translations.sample[this.language]))])]), _vm._v(" "), _c('div', {
    staticClass: "page-block sample",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('pre', [_vm._v("{")])]), _vm._v(" "), _vm._l((_vm.response.sample), function(entry, key, index) {
    return _c('div', {
      staticClass: "page-block",
      staticStyle: {
        "padding-bottom": "0"
      },
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('pre', {
      staticStyle: {
        "font-size": "10px",
        "padding-left": "30px"
      }
    }, [_vm._v(_vm._s(key) + ": " + _vm._s(entry) + _vm._s(index !== Object.values(_vm.response.sample).length - 1 ? ',' : ''))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "page-block sample",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('pre', [_vm._v("}")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9457f436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ddf/Ddf.vue
// module id = 709
// module chunks = 0